import { mapActions } from 'vuex';

export default {
  computed: {
    modelNamespace() {
      return `models/${this.modelName}`;
    },

    getStateFromNamespace() {
      const state = this.$store.state;
      let module = this.modelNamespace.split('/')[0];
      let model = this.modelNamespace.split('/')[1];

      if (state[module] && state[module][model]) {
        return state[module][model];
      }

      return {};
    },

    search() {
      return this.getStateFromNamespace.currentTableSearch;
    },
    page() {
      return this.getStateFromNamespace.currentTablePage;
    },
    perPage() {
      return this.getStateFromNamespace.currentTablePerPage;
    },

    // used in fetchVisits from VisitsTable.vue component
    author() {
      return this.getStateFromNamespace.currentTableAuthor;
    },
    dateFrom() {
      return this.getStateFromNamespace.currentTableDateFrom;
    },
    dateTo() {
      return this.getStateFromNamespace.currentTableDateTo;
    },

    // used in fetchTableData from ProducersTable.vue component
    city() {
      return this.getStateFromNamespace.currentTableCity;
    },
  },
  methods: {
    ...mapActions({
      setSearch(dispatch, payload) {
        return dispatch(`${this.modelNamespace}/setCurrentTableSearch`, payload);
      },
      setPage(dispatch, payload) {
        return dispatch(`${this.modelNamespace}/setCurrentTablePage`, payload);
      },
      setPerPage(dispatch, payload) {
        return dispatch(`${this.modelNamespace}/setCurrentTablePerPage`, payload);
      },
      setAuthor(dispatch, payload) {
        return dispatch(`${this.modelNamespace}/setCurrentTableAuthor`, payload);
      },
      setDateFrom(dispatch, payload) {
        return dispatch(`${this.modelNamespace}/setCurrentTableDateFrom`, payload);
      },
      setDateTo(dispatch, payload) {
        return dispatch(`${this.modelNamespace}/setCurrentTableDateTo`, payload);
      },
      setCity(dispatch, payload) {
        return dispatch(`${this.modelNamespace}/setCurrentTableCity`, payload);
      },
    }),
  },
};
